export const DHCP_CODE = 43;
